module.exports = __webpack_public_path__ + "static/img/user-full.0a919c71.jpg";